/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceInstance } from 'app/models/service-instance';
import { ServiceService } from 'app/services/service.service';
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "app/components/simple-success-error-dialog-box/simple-success-error-dialog-box.component";
import { CartonAuditService, CartonAuditService_StateEnum } from "app/services/carton-audit.service";


@Component({
  selector: 'app-carton-audit-enter-info',
  templateUrl: './carton-audit-enter-info.component.html',
  styleUrls: ['./carton-audit-enter-info.component.css']
})
export class CartonAuditEnterInfoComponent implements OnInit, AfterViewInit {
  serviceInstance: ServiceInstance | null = null;
  cartonId: string = '';
  isUiDisabled = false;

 @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cartonAuditService: CartonAuditService,
    private serviceService: ServiceService
  ) {}

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.serviceInstance = await this.serviceService.getServiceInstanceById(id);
    }
  }

  /**
   * Initializes the component view.  
   * Called automatically by the Angular Component Lifecycle.
   * 
   * Used to auto-focus on the "Carton ID / Barcode" input field.  
   */
  ngAfterViewInit(): void {
    // Auto-focus on the "Carton ID" input (Not using the "[autofocus]" as that only works the 1st time the page is displayed, not after migrating back after clearing / processing an order)
    const element = document.getElementById("cartonId");
    if (element != null && element != undefined) {
      element.focus();
    }
  }

  async onSubmit() {
    if (!this.cartonId) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE,'Carton ID cannot be empty.');
      return;
    }

    try {
      this.isUiDisabled = true;
      const state = await this.cartonAuditService.enterCartonId(
        this.serviceInstance!.id,
        this.cartonId
      );
      console.log("state"+state);

      if (state.state === CartonAuditService_StateEnum.CartonBeingAudited) {
        this.router.navigate(['jockey','carton-audit', this.serviceInstance.id, 'dashboard'],{ state: { auditState: state } } );
      } else {
        this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE,`Unexpected State: ${state.state}`);
      }
    } catch (err: any) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE,'Please enter valid Carton ID.');
    } finally {
      this.isUiDisabled = false;
    }
  }
}
